import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { History } from "lucide-react";
import { useApi } from "@/lib/useApi";
import { errMsg, formatDate, formatRp } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const VersionsPanel = ({ productId, reloadKey, onRestored }) => {
  const call = useApi();
  const [list, setList] = useState([]);
  const load = useCallback(() => call("get", `/admin/products/${productId}/versions`).then(setList), [call, productId]);
  useEffect(() => { load(); }, [load, reloadKey]);

  const restore = async (v) => {
    if (!window.confirm(`Kembalikan produk ke versi ${formatDate(v.saved_at)}?`)) return;
    try { onRestored(await call("post", `/admin/products/${productId}/versions/${v.id}/restore`)); toast.success("Versi dikembalikan"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <section className="rounded-lg border border-stone-200 bg-white p-4" data-testid="product-versions">
      <h2 className="mb-3 flex items-center gap-2 font-semibold"><History className="h-4 w-4" /> Riwayat perubahan (10 terakhir)</h2>
      {list.length === 0 ? <p className="text-sm text-stone-500">Belum ada perubahan tersimpan.</p> : (
        <ul className="divide-y divide-stone-100">
          {list.map((v) => (
            <li key={v.id} className="flex items-center gap-3 py-2 text-sm" data-testid={`version-row-${v.id}`}>
              <div className="min-w-0 flex-1">
                <p className="truncate font-medium">{v.name} <span className="font-normal text-stone-500">· {v.sku}</span></p>
                <p className="text-xs text-stone-500">{formatDate(v.saved_at)} · {v.saved_by || "-"} · {formatRp(v.price)} · stok {v.stock} · {v.status}</p>
              </div>
              <Button type="button" size="sm" variant="outline" data-testid={`version-restore-${v.id}`} onClick={() => restore(v)}>Kembalikan</Button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
